module.exports = "<ion-router-outlet class=\"outlet\" id=\"main-content\"></ion-router-outlet>\n"